import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import AppLayout from "./components/AppLayout";
import { Toaster } from "./components/ui/sonner";

import LoginPage from "./pages/LoginPage";
import ResetPasswordPage from "./pages/ResetPasswordPage";
import DashboardPage from "./pages/DashboardPage";
import LearnPage from "./pages/LearnPage";
import IncomePage from "./pages/IncomePage";
import ExpensesPage from "./pages/ExpensesPage";
import BankFeedsPage from "./pages/BankFeedsPage";
import BASPage from "./pages/BASPage";
import ProfitLossPage from "./pages/ProfitLossPage";
import CategoriesPage from "./pages/CategoriesPage";
import FixedCostsPage from "./pages/FixedCostsPage";
import PayrollPage from "./pages/PayrollPage";
import InvoicesPage from "./pages/InvoicesPage";
import QuotesPage from "./pages/QuotesPage";
import QuoteViewPage from "./pages/QuoteViewPage";
import ProjectsPage from "./pages/ProjectsPage";
import LoansPage from "./pages/LoansPage";
import DrawingsPage from "./pages/DrawingsPage";
import BankAccountsPage from "./pages/BankAccountsPage";
import PersonalBankingPage from "./pages/PersonalBankingPage";
import BillsPage from "./pages/BillsPage";
import SettingsPage from "./pages/SettingsPage";

const withLayout = (el) => (
  <ProtectedRoute>
    <AppLayout>{el}</AppLayout>
  </ProtectedRoute>
);

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route path="/reset-password" element={<ResetPasswordPage />} />
            <Route path="/q/:token" element={<QuoteViewPage />} />
            <Route path="/" element={withLayout(<DashboardPage />)} />
            <Route path="/income" element={withLayout(<IncomePage />)} />
            <Route path="/expenses" element={withLayout(<ExpensesPage />)} />
            <Route path="/bank" element={withLayout(<BankFeedsPage />)} />
            <Route path="/bas" element={withLayout(<BASPage />)} />
            <Route path="/pnl" element={withLayout(<ProfitLossPage />)} />
            <Route path="/categories" element={withLayout(<CategoriesPage />)} />
            <Route path="/fixed-costs" element={withLayout(<FixedCostsPage />)} />
            <Route path="/payroll" element={withLayout(<PayrollPage />)} />
            <Route path="/invoices" element={withLayout(<InvoicesPage />)} />
            <Route path="/quotes" element={withLayout(<QuotesPage />)} />
            <Route path="/projects" element={withLayout(<ProjectsPage />)} />
            <Route path="/loans" element={withLayout(<LoansPage />)} />
            <Route path="/drawings" element={withLayout(<DrawingsPage />)} />
            <Route path="/accounts" element={withLayout(<BankAccountsPage />)} />
            <Route path="/personal" element={withLayout(<PersonalBankingPage />)} />
            <Route path="/bills" element={withLayout(<BillsPage />)} />
            <Route path="/settings" element={withLayout(<SettingsPage />)} />
            <Route path="/learn" element={withLayout(<LearnPage />)} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
